<template>
	<div class="header-nav" :class="{ 'gray': gray }">
		<div class="left">
			<img src="../assets/logo.png" style="width: 8.0625rem;">
		</div>

		<div class="right">
			<div class="r-item r-nav" v-for="(item, index) in nav" @click="hClick(index)">
				<span>{{ item.name }}</span>
				<!-- <img v-if="index == navIndex" src="../assets/nav-current.png" > -->
			</div>
			<div class="r-item">
				<span class="lang" @click="showSelectLang = !showSelectLang">{{ currentLang }}</span>
				<div class="lang-box" v-show="showSelectLang">
					<span v-for="(item, index) in langList" @click="hSwitchLang(item)">
						{{ item.country }}
					</span>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getLanguage,
	getMenuList
} from '@/utils/api.js'
export default {
	name: 'HeaderNav',
	props: {
		navIndex: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			nav: [{
				name: this.$t('nav.home'),
				index: 0
			},
			{
				name: this.$t('nav.about'),
				index: 1
			},
			{
				name: this.$t('nav.project'),
				index: 2
			},
			{
				name: this.$t('nav.contact'),
				index: 3
			}
			],
			currentInd: 0,

			showSelectLang: false,
			currentLang: this.$t('nav.language'),
			langList: []

		}
	},
	mounted() {

	},
	created() {
		this.getLanguage()
	},
	computed: {
		...mapState(['gray'])
	},
	methods: {
		// 选择语言 切换
		hSwitchLang(langInfo) {
			// console.log("langInfo: ",langInfo);

			localStorage.setItem('lang', JSON.stringify(langInfo))
			this.currentLang = JSON.parse(localStorage.getItem('lang')).country

			this.showSelectLang = false // 关闭显示
			location.reload() // 强制刷新当前页面
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		// 获取语言列表
		async getLanguage() {
			const res = await getLanguage()
			if (res.code == 200) {
				this.langList = res.content

				// 默认存储 英文语言
				// const langIndex = this.langList.indexOf(this.langList.filter(d=>d.abbreviation == 'EN')[0])
				// localStorage.setItem('lang', JSON.stringify(this.langList[langIndex]))
			}
		},
		hClick(index) {
			this.$emit('click', index)
		}
	}
}
</script>

<style scoped>
.header-nav {
	/* color: #FFFFFF; */
	max-width: 75rem;
	/* padding: 0.9375rem; */
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0.75rem 0;
}

.left {
	width: 8.0625rem;
}

.right {
	flex: 1;
	display: flex;
	justify-content: flex-end;
}

.r-item {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 1.25rem;
	position: relative;
}

.r-item span {
	font-size: 16px;
	color: #171717;
	cursor: pointer;
}

.r-item img {
	margin-top: 1.25rem;
}

.lang-box {
	width: 100px;
	position: absolute;
	top: 40px;
	right: -30%;
	padding: 0 10px;
	z-index: 2222;
	background-color: #FFFFFF;
	box-shadow: 0px 0px 4px 0px rgba(59, 59, 59, 0.2);
	border-radius: 6px;
	text-align: center;
}

.lang-box span {
	display: block;
	padding: 10px 0;
	color: #333333;
	border-bottom: 1px solid #CCCCCC;
}

.lang-box span:last-child {
	border: none;
}

.r-item .lang:after {
	content: "";
	display: inline-block;
	margin-left: 4px;
	width: 0;
	height: 0;
	border-left: 8px solid transparent;
	border-right: 8px solid transparent;
	border-top: 10px solid #666;
	border-radius: 3px;
}

.lang-box:after {
	content: '';
	position: absolute;
	bottom: 100%;
	left: 50%;
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	border-bottom: 10px solid #fff;
	margin-left: -5px;
}

@media screen and (max-width:480px) {
	.r-nav {
		display: none;
	}
}
</style>

